module.exports = __webpack_public_path__ + "static/media/first-step-icon.1961081c.svg";